// extracted by mini-css-extract-plugin
export default {"carousel-swiper":"NJWtkspylybrrkbiB6Au","carouselSwiper":"NJWtkspylybrrkbiB6Au","save-for-later-widget":"iT0y7UWGbAgDqO1U9CLU","saveForLaterWidget":"iT0y7UWGbAgDqO1U9CLU"};